import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FLOWS, sendStats } from '../../../../../services/mixpanel';
import { MXP_CARD_ORDER_PAYMENT_METHOD_VISIT } from '../../mixpanel-events';
import { OrderCardContext } from '../../../../../contexts/card/cardOrder/context';
import { CardPaymentMethods, mainCardTypes, orderCardFlowScreens } from '../../../constants';
import ModalBodyLayout from '../partials/MainBodyLayout';
import AddAccount from '../../../../Accounts/partials/AddAccount';

const SelectPaymentType = () => {
  const { t: translate } = useTranslation();
  const { state, openScreen, updatePaymentInfo } = useContext(OrderCardContext);

  // Settings
  const featurePgwAllowed = state?.cardOrderSettings?.app?.feature_pgw_allowed;
  const pgwAllowCryptoExchange = state?.cardOrderSettings?.pgw?.pgw_allow_crypto_exchange;
  const pgwWarningMessage = state?.cardOrderSettings?.ui?.feature_pgw_warning_message;
  const showPgwWarning = state?.cardOrderSettings?.ui?.feature_allow_pgw_warning;
  const featureAllowCardOrderPaymentStablecoin =
    state?.cardOrderSettings?.app?.feature_allow_card_order_payment_stablecoin;
  const featureAllowCardOrderPaymentCrypto =
    state?.cardOrderSettings?.app?.feature_allow_card_order_payment_crypto;

  // State values
  const mainCardType = state?.mainCardType;

  useEffect(() => {
    sendStats(MXP_CARD_ORDER_PAYMENT_METHOD_VISIT, {}, FLOWS.CARD_ORDER);
  }, []);

  const paymentMethods = useMemo(
    () => [
      {
        id: 0,
        title: translate('pay_with_crypto'),
        icon: ['icon-cryptocoin', 2],
        type: CardPaymentMethods.CRYPTO_OR_STABLE,
        enabled: featureAllowCardOrderPaymentCrypto || featureAllowCardOrderPaymentStablecoin,
      },
      {
        id: 2,
        title: translate('pay_with_card'),
        icon: ['icon-outline-menu', 2],
        type: CardPaymentMethods.PGW,
        enabled: featurePgwAllowed && pgwAllowCryptoExchange,
      },
    ],
    [
      featureAllowCardOrderPaymentCrypto,
      featurePgwAllowed,
      pgwAllowCryptoExchange,
      featureAllowCardOrderPaymentStablecoin,
      translate,
    ]
  );

  const selectPaymentMethod = (type) => {
    updatePaymentInfo('method', type);
    // updateForm({ ...form, paymentMethodType: type });
    if (type !== CardPaymentMethods.PGW) {
      openScreen(orderCardFlowScreens.SELECT_PAYMENT);
    } else {
      openScreen(orderCardFlowScreens.PROCEED_WITH_PAYMENT);
    }
  };

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() => {
        openScreen(
          mainCardType === mainCardTypes.PHYSICAL
            ? orderCardFlowScreens.CONFIRM_DETAILS
            : orderCardFlowScreens.CONFIRM_VIRTUAL_DETAILS
        );
      }}
      title={translate('card_order_select_payment_title')}>
      <div className="mt-4">
        {paymentMethods.map((methodPayment) =>
          methodPayment.enabled ? (
            <div key={methodPayment.id}>
              <AddAccount
                label={methodPayment.title}
                icon={methodPayment.icon}
                subLabel={methodPayment.subtext}
                className="my-2 bg-lighter"
                noMobile
                onClick={() => {
                  selectPaymentMethod(methodPayment.type);
                }}
              />
            </div>
          ) : (
            ''
          )
        )}
      </div>
      {showPgwWarning && (
        <div className="alert alert-info mb-4 mt-4">
          <i className="icon icon-info-icon" />
          <span className="content text-left">{pgwWarningMessage}</span>
        </div>
      )}
    </ModalBodyLayout>
  );
};

export default SelectPaymentType;
